import { v4 as uuidv4 } from "uuid";
import { displayContentModal } from "../../../utils";
import styles from "./SideModal.module.css";
import ImageSlider from "../ImageSlider/ImageSlider";
import { useState } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { setCurrentModule } from "../../../store/reducers/progressionReducer";
import { useDispatch } from "react-redux";
import ImageSolo from "../ImageSlider/ImageSolo";

export default function SideModal({
  title,
  priorities,
  texts,
  images,
  pagination,
  buttons,
  introContent,
}) {
  const [idx, setIdx] = useState(0);
  const dispatch = useDispatch();
  const { contextSafe } = useGSAP();

  useGSAP(() => {
    gsap.to(".sideModalFrame", { opacity: 1, x: 0, duration: 1, ease: "power2.out" });
  });

  useGSAP(
    () => {
      // Animation page
    },
    { dependencies: [idx] },
  );

  function displayContentModalPagination() {
    let indexText = 0;
    let indexImage = 0;
    let indexButton = 0;

    return priorities.map((elt, i) => {
      if (Array.isArray(elt)) {
        return (
          <div key={uuidv4()} className={`${styles.page} ${i === idx ? styles.active : ""}`}>
            {elt.map((subElt) => {
              if (subElt === "text") {
                return (
                  <p className={styles.text} key={uuidv4()}>
                    {texts[indexText++]}
                  </p>
                );
              } else if (subElt === "image") {
                const currentImage = images[indexImage++];
                return currentImage.type && currentImage.type === "slider" ? (
                  <ImageSlider key={uuidv4()} images={currentImage} />
                ) : (
                  <ImageSolo key={uuidv4()} images={currentImage} />
                );
              } else if (subElt === "button" && buttons) {
                return (
                  <a
                    href={buttons[indexButton].href}
                    key={uuidv4()}
                    className={styles.button}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{buttons[indexButton++].content}</span>
                    <span className={styles.linkArrow}>→</span>
                  </a>
                );
              }
              return null;
            })}
          </div>
        );
      } else if (elt === "text") {
        return (
          <div key={uuidv4()} className={`${styles.page} ${i === idx ? styles.active : ""}`}>
            <p className={styles.text} key={uuidv4()}>
              {texts[indexText++]}
            </p>
          </div>
        );
      } else if (elt === "image") {
        const currentImage = images[indexImage++];
        return (
          <div key={uuidv4()} className={`${styles.page} ${i === idx ? styles.active : ""}`}>
            {currentImage.type && currentImage.type === "slider" ? (
              <ImageSlider key={uuidv4()} images={currentImage} />
            ) : (
              <ImageSolo key={uuidv4()} images={currentImage} />
            )}
          </div>
        );
      }
      return null;
    });
  }

  function displayInputsRadio() {
    return (
      <div className={styles.radioInputs}>
        {priorities.map((elt, i) => (
          <div className={styles.radio} key={uuidv4()}>
            <input
              type="radio"
              id={`page_${i}`}
              name="imagesSlider"
              value={i}
              checked={i === idx}
              onChange={() => setIdx(i)}
            />
            <label htmlFor={`page_${i}`}></label>
          </div>
        ))}
      </div>
    );
  }

  const closeEvent = contextSafe(() => {
    gsap
      .timeline({
        onComplete: () => {
          dispatch(setCurrentModule("none"));
        },
      })
      .to(".sideModalFrame", {
        opacity: 0,
        x: "100%",
        duration: 0.5,
        ease: "power2.in",
      });
  });

  return (
    <div className={`${styles.sideModal} sideModalFrame`}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {introContent && <p className={styles.subtitle}>{introContent}</p>}
      </div>

      <div className={styles.content}>
        {pagination ? (
          <>
            {displayContentModalPagination()}
            {displayInputsRadio()}
          </>
        ) : (
          displayContentModal(priorities, texts, images, styles, buttons)
        )}
      </div>

      <button className={styles.closeButton} onClick={closeEvent} aria-label="Fermer"></button>
    </div>
  );
}
